/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Mobilefreebies_Collapse1Inputs */

const id_components_mobilefreebies_collapse1 = /** @type {(inputs: Components_Mobilefreebies_Collapse1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciutkan game gratis seluler`)
};

const ms_components_mobilefreebies_collapse1 = /** @type {(inputs: Components_Mobilefreebies_Collapse1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lipat permainan percuma mudah alih`)
};

const da_components_mobilefreebies_collapse1 = /** @type {(inputs: Components_Mobilefreebies_Collapse1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skjul mobile gratis spil`)
};

const de_components_mobilefreebies_collapse1 = /** @type {(inputs: Components_Mobilefreebies_Collapse1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobile kostenlose Spiele einklappen`)
};

const en_us2_components_mobilefreebies_collapse1 = /** @type {(inputs: Components_Mobilefreebies_Collapse1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collapse mobile free games`)
};

const es_es2_components_mobilefreebies_collapse1 = /** @type {(inputs: Components_Mobilefreebies_Collapse1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colapsar juegos gratis móviles`)
};

const es_mx2_components_mobilefreebies_collapse1 = /** @type {(inputs: Components_Mobilefreebies_Collapse1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contraer juegos gratis móviles`)
};

const fil_components_mobilefreebies_collapse1 = /** @type {(inputs: Components_Mobilefreebies_Collapse1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-collapse ang mobile free games`)
};

const fr_components_mobilefreebies_collapse1 = /** @type {(inputs: Components_Mobilefreebies_Collapse1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réduire les jeux gratuits mobiles`)
};

const it_components_mobilefreebies_collapse1 = /** @type {(inputs: Components_Mobilefreebies_Collapse1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprimi giochi gratuiti mobile`)
};

const hu_components_mobilefreebies_collapse1 = /** @type {(inputs: Components_Mobilefreebies_Collapse1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobil ingyenes játékok összecsukása`)
};

const nl_components_mobilefreebies_collapse1 = /** @type {(inputs: Components_Mobilefreebies_Collapse1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobiele gratis games samenvouwen`)
};

const no_components_mobilefreebies_collapse1 = /** @type {(inputs: Components_Mobilefreebies_Collapse1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skjul mobil gratis spill`)
};

const pl_components_mobilefreebies_collapse1 = /** @type {(inputs: Components_Mobilefreebies_Collapse1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwiń darmowe gry mobilne`)
};

const pt_br2_components_mobilefreebies_collapse1 = /** @type {(inputs: Components_Mobilefreebies_Collapse1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collapse mobile free games`)
};

const pt_components_mobilefreebies_collapse1 = /** @type {(inputs: Components_Mobilefreebies_Collapse1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrair jogos grátis móveis`)
};

const ro_components_mobilefreebies_collapse1 = /** @type {(inputs: Components_Mobilefreebies_Collapse1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restrânge jocurile gratuite mobile`)
};

const fi_components_mobilefreebies_collapse1 = /** @type {(inputs: Components_Mobilefreebies_Collapse1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kutista mobiilin ilmaispelit`)
};

const sv_components_mobilefreebies_collapse1 = /** @type {(inputs: Components_Mobilefreebies_Collapse1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dölj mobil gratisspel`)
};

const vi_components_mobilefreebies_collapse1 = /** @type {(inputs: Components_Mobilefreebies_Collapse1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thu gọn game miễn phí di động`)
};

const tr_components_mobilefreebies_collapse1 = /** @type {(inputs: Components_Mobilefreebies_Collapse1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobil ücretsiz oyunları daralt`)
};

const cs_components_mobilefreebies_collapse1 = /** @type {(inputs: Components_Mobilefreebies_Collapse1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sbalit mobilní hry zdarma`)
};

const bg_components_mobilefreebies_collapse1 = /** @type {(inputs: Components_Mobilefreebies_Collapse1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Свиване на мобилните безплатни игри`)
};

const ru_components_mobilefreebies_collapse1 = /** @type {(inputs: Components_Mobilefreebies_Collapse1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Свернуть мобильные бесплатные игры`)
};

const uk_components_mobilefreebies_collapse1 = /** @type {(inputs: Components_Mobilefreebies_Collapse1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Згорнути мобільні безкоштовні ігри`)
};

const ar_components_mobilefreebies_collapse1 = /** @type {(inputs: Components_Mobilefreebies_Collapse1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`طي الألعاب المجانية للجوال`)
};

const hi_components_mobilefreebies_collapse1 = /** @type {(inputs: Components_Mobilefreebies_Collapse1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संक्षिप्त करें`)
};

const th_components_mobilefreebies_collapse1 = /** @type {(inputs: Components_Mobilefreebies_Collapse1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยุบเกมฟรีบนมือถือ`)
};

const ja_components_mobilefreebies_collapse1 = /** @type {(inputs: Components_Mobilefreebies_Collapse1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`モバイル無料ゲームを折りたたむ`)
};

const zh_cn2_components_mobilefreebies_collapse1 = /** @type {(inputs: Components_Mobilefreebies_Collapse1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collapse mobile free games`)
};

const zh_hant1_components_mobilefreebies_collapse1 = /** @type {(inputs: Components_Mobilefreebies_Collapse1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collapse mobile free games`)
};

const ko_components_mobilefreebies_collapse1 = /** @type {(inputs: Components_Mobilefreebies_Collapse1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collapse mobile free games`)
};

/**
* | output |
* | --- |
* | "Collapse mobile free games" |
*
* @param {Components_Mobilefreebies_Collapse1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_mobilefreebies_collapse1 = /** @type {((inputs?: Components_Mobilefreebies_Collapse1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Mobilefreebies_Collapse1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_mobilefreebies_collapse1(inputs)
	if (locale === "ms") return ms_components_mobilefreebies_collapse1(inputs)
	if (locale === "da") return da_components_mobilefreebies_collapse1(inputs)
	if (locale === "de") return de_components_mobilefreebies_collapse1(inputs)
	if (locale === "en-US") return en_us2_components_mobilefreebies_collapse1(inputs)
	if (locale === "es-ES") return es_es2_components_mobilefreebies_collapse1(inputs)
	if (locale === "es-MX") return es_mx2_components_mobilefreebies_collapse1(inputs)
	if (locale === "fil") return fil_components_mobilefreebies_collapse1(inputs)
	if (locale === "fr") return fr_components_mobilefreebies_collapse1(inputs)
	if (locale === "it") return it_components_mobilefreebies_collapse1(inputs)
	if (locale === "hu") return hu_components_mobilefreebies_collapse1(inputs)
	if (locale === "nl") return nl_components_mobilefreebies_collapse1(inputs)
	if (locale === "no") return no_components_mobilefreebies_collapse1(inputs)
	if (locale === "pl") return pl_components_mobilefreebies_collapse1(inputs)
	if (locale === "pt-BR") return pt_br2_components_mobilefreebies_collapse1(inputs)
	if (locale === "pt") return pt_components_mobilefreebies_collapse1(inputs)
	if (locale === "ro") return ro_components_mobilefreebies_collapse1(inputs)
	if (locale === "fi") return fi_components_mobilefreebies_collapse1(inputs)
	if (locale === "sv") return sv_components_mobilefreebies_collapse1(inputs)
	if (locale === "vi") return vi_components_mobilefreebies_collapse1(inputs)
	if (locale === "tr") return tr_components_mobilefreebies_collapse1(inputs)
	if (locale === "cs") return cs_components_mobilefreebies_collapse1(inputs)
	if (locale === "bg") return bg_components_mobilefreebies_collapse1(inputs)
	if (locale === "ru") return ru_components_mobilefreebies_collapse1(inputs)
	if (locale === "uk") return uk_components_mobilefreebies_collapse1(inputs)
	if (locale === "ar") return ar_components_mobilefreebies_collapse1(inputs)
	if (locale === "hi") return hi_components_mobilefreebies_collapse1(inputs)
	if (locale === "th") return th_components_mobilefreebies_collapse1(inputs)
	if (locale === "ja") return ja_components_mobilefreebies_collapse1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_mobilefreebies_collapse1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_mobilefreebies_collapse1(inputs)
	return ko_components_mobilefreebies_collapse1(inputs)
});
export { components_mobilefreebies_collapse1 as "components.mobileFreebies.collapse" }